import { Card, Flex, Grid, Text } from '@servicetitan/anvil2';
import { DataItem, formatCurrency } from '@servicetitan/financing-utils-shared';
import { PrequalificationDecisionDataStore } from './PrequalificationDecisionDataStore';

export const PrequalificationDetails = () => {
    const { prequalDecisionData } = PrequalificationDecisionDataStore.useStore();

    const { externalPrequalId, status, approvedAmount } = prequalDecisionData ?? {};
    const date = new Date().toLocaleDateString();

    // Format status for display
    const statusDisplay = status
        ? status.charAt(0).toUpperCase() + status.slice(1).toLowerCase()
        : '';

    return (
        <Card flexDirection="column" style={{ maxWidth: '845px', width: '100%' }}>
            <Flex gap="3" direction="column">
                <Text variant="headline" el="h2" size="small">
                    Summary
                </Text>
                <Grid rowGap="4" templateColumns="repeat(auto-fit, minmax(255px, 1fr))">
                    <Flex direction="column" gap="2">
                        <DataItem label="Pre-Qualification ID" text={externalPrequalId} />
                        <Text variant="body" subdued size="small">
                            Record your Prequal ID. You will need this information to access your
                            account in the future.
                        </Text>
                    </Flex>
                    <DataItem
                        label="Maximum Credit Amount"
                        text={formatCurrency(approvedAmount ?? 0)}
                    />
                    <DataItem label="Status" text={statusDisplay} />
                    <DataItem label="Date" text={date} />
                </Grid>
            </Flex>
        </Card>
    );
};
